export default __webpack_public_path__ + "e8bffd2929e02bfd870e82af179844cb.png";